<template>
  <pre style="white-space: pre-line;">{{ log }}</pre>
</template>

<script>
export default {
  data() {
    return {
      log: ""
    };
  },
  created() {
    this.$http.get("/api/v1/logs/dialog").then(({ data }) => (this.log = data));
  }
};
</script>
